import { render, staticRenderFns } from "./Changepassword.vue?vue&type=template&id=678f25d2&scoped=true"
import script from "./Changepassword.vue?vue&type=script&lang=js"
export * from "./Changepassword.vue?vue&type=script&lang=js"
import style0 from "./Changepassword.vue?vue&type=style&index=0&id=678f25d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678f25d2",
  null
  
)

export default component.exports